var map = {
	"./bat.svg": 154,
	"./beaver.svg": 155,
	"./bee.svg": 156,
	"./beetle.svg": 157,
	"./bulldog.svg": 158,
	"./camel.svg": 159,
	"./canary.svg": 160,
	"./cat.svg": 161,
	"./chameleon.svg": 162,
	"./chicken.svg": 163,
	"./clown-fish.svg": 164,
	"./cobra.svg": 165,
	"./cow.svg": 166,
	"./crab.svg": 167,
	"./crocodile.svg": 168,
	"./duck.svg": 169,
	"./elephant.svg": 170,
	"./fox.svg": 171,
	"./frog.svg": 172,
	"./giraffe.svg": 173,
	"./hippopotamus.svg": 174,
	"./humming-bird.svg": 175,
	"./kangaroo.svg": 176,
	"./lion.svg": 177,
	"./llama.svg": 178,
	"./macaw.svg": 179,
	"./monkey.svg": 180,
	"./moose.svg": 181,
	"./mouse.svg": 182,
	"./octopus.svg": 183,
	"./ostrich.svg": 184,
	"./owl.svg": 185,
	"./panda.svg": 186,
	"./pelican.svg": 187,
	"./penguin.svg": 188,
	"./pig.svg": 189,
	"./rabbit.svg": 190,
	"./racoon.svg": 191,
	"./rhinoceros.svg": 192,
	"./shark.svg": 193,
	"./sheep.svg": 194,
	"./siberian-husky.svg": 195,
	"./sloth.svg": 196,
	"./snake.svg": 197,
	"./squirrel.svg": 198,
	"./swan.svg": 199,
	"./tiger.svg": 200,
	"./toucan.svg": 201,
	"./turtle.svg": 202,
	"./whale.svg": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;